import { Component, OnInit, Input, OnChanges, ChangeDetectorRef, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'image-lazyload-control',
    templateUrl: './image-lazyload-control.component.html',
    styleUrls: ['./image-lazyload-control.component.scss']
})
export class ImageLazyloadControlComponent implements OnInit, OnChanges {
    @Input() imgSrcInput: string;
    /** Tried once if the primary src fails (e.g. broken ImageKit preview transform). */
    @Input() imgFallbackInput: string;
    imgSrc: string;
    RetryInterval;
    isRetrying: boolean = false;
    isError: boolean = false;
    isImageLoaded: boolean = false;

    constructor(private detector: ChangeDetectorRef) {
        detector.detach();
    }

    ngOnInit(): void { }

    ngOnChanges() {
        if (this.RetryInterval) {
            clearInterval(this.RetryInterval);
            this.RetryInterval = null;
        }
        this.imgSrc = this.imgSrcInput;
        this.isImageLoaded = false;
        this.isError = false;
        if (!this.imgSrcInput) {
            this.isRetrying = false;
            this.isError = true;
            this.detector.detectChanges();
            return;
        }
        this.isRetrying = true;
        this.detector.detectChanges();
    }

    public imgOnload(e) {
        this.isImageLoaded = true;
        this.isRetrying = false;
        this.isError = false;
        if (this.RetryInterval) {
            clearInterval(this.RetryInterval);
            this.RetryInterval = null;
        }
        this.detector.detectChanges();
    }

    public waitAndReload(event) {
        if (!this.imgSrcInput) {
            this.isImageLoaded = false;
            this.isRetrying = false;
            this.isError = true;
            this.detector.detectChanges();
            return;
        }

        const fallback = (this.imgFallbackInput || '').trim();
        const currentSrc = event && event.target ? event.target.src : '';
        if (
            fallback &&
            event && event.target &&
            !event.target.getAttribute('data-tried-fallback') &&
            currentSrc.indexOf(fallback.split('?')[0]) === -1
        ) {
            event.target.setAttribute('data-tried-fallback', '1');
            this.imgSrc = fallback;
            event.target.src = fallback;
            this.isImageLoaded = false;
            this.isRetrying = true;
            this.isError = false;
            this.detector.detectChanges();
            return;
        }

        // Same broken URL rarely recovers — fail after a couple of retries, not 15.
        if (!this.RetryInterval) {
            const originalSrc = event.target.src;
            this.RetryInterval = setInterval(() => {
                const retry = parseInt(event.target.getAttribute('data-retry'), 10) || 0;
                const maxRetry = parseInt(event.target.getAttribute('data-max-retry'), 10) || 2;
                if (retry < maxRetry) {
                    event.target.setAttribute('data-retry', String(retry + 1));
                    event.target.src = originalSrc;
                    this.isImageLoaded = false;
                    this.isRetrying = true;
                    this.isError = false;
                    this.detector.detectChanges();
                } else {
                    clearInterval(this.RetryInterval);
                    this.RetryInterval = null;
                    event.target.src = '';
                    this.isImageLoaded = false;
                    this.isRetrying = false;
                    this.isError = true;
                    this.detector.detectChanges();
                }
            }, 1500);
        }
    }
}
